/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IThemeRefItem, IThemeRefResolver, TThemeStyleNames } from "@adapptio/lib-blueprint";
import { RESOURCE_TYPES } from "@adapptio/lib-core";
import { createEventEmitter, emitEvent, offEvent, onEvent } from "@adapptio/lib-shared";
import { ResourceService } from "../../resources/ResourceService";
import { IEditorResource_Theme } from "../../resources/ResourceTypes";

export class ThemeRefResolver implements IThemeRefResolver {
	/** Invalidate event */
	public onInvalidate = createEventEmitter<void>();

	private invalidateHandler: (resourceType: RESOURCE_TYPES) => void;

	public constructor(private resourceSvc: ResourceService) {
		this.invalidateHandler = (resourceType) => {
			if (resourceType === RESOURCE_TYPES.THEME) {
				emitEvent(this.onInvalidate);
			}
		};

		onEvent(this.resourceSvc.onResourceTypeChange, this.invalidateHandler);
	}

	public getThemeList(): IThemeRefItem[] {
		console.log(
			"editor getThemeList:",
			this.resourceSvc.getResourceListByType<RESOURCE_TYPES.THEME>(RESOURCE_TYPES.THEME)
		);

		return this.resourceSvc
			.getResourceListByType<RESOURCE_TYPES.THEME>(RESOURCE_TYPES.THEME)
			.map((resource) => ({
				themeId: resource.id,
				label: resource.descriptor.name,
				styles: resource.descriptor?.parseData?.styles
			}));
	}

	/** Return Theme Styles */
	public getStylesById(themeId: string): TThemeStyleNames {
		const resource = this.resourceSvc.getResourceById(themeId) as IEditorResource_Theme;

		if (!resource) {
			return null;
		}

		return resource.descriptor?.parseData?.styles;
	}

	public dispose(): void {
		offEvent(this.resourceSvc.onResourceTypeChange, this.invalidateHandler);
	}
}
